import setupEditComponent from './setup.edit.component';

let setupEditModule = angular.module('setupedit', [
  ])

  .component('setupedit', setupEditComponent)

  .name;

export default setupEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/edit/index.js